import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/slices/authSlice';
import VersionInfoPopup from './VersionInfoPopup';

export default function UserMenu() {
  const menuRef = useRef(null);
  const versionInfoPopupRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  // 将用户图标点击交给版本信息组件处理
  const handleVersionInfoClick = () => {
    versionInfoPopupRef.current?.handleTriggerClick();
  };

  return (
    <div className="relative group" ref={menuRef} tabIndex={0}>
      <VersionInfoPopup ref={versionInfoPopupRef} />

      {/* User Menu Button (hover to open) */}
      <button
        className="p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors duration-200 cursor-pointer"
        aria-haspopup="true"
        onClick={handleVersionInfoClick}
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          width="20"
          height="20"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          />
        </svg>
      </button>

      {/* Dropdown Menu - shown on hover or focus */}
      <div className="absolute right-0 -mt-1 w-48 bg-white rounded-lg shadow-lg border border-slate-200 overflow-hidden z-50 opacity-0 scale-95 pointer-events-none transform transition-all duration-200 group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:scale-100 group-focus-within:pointer-events-auto">
        {/* Menu Header */}
        <div className="px-4 py-3 border-b border-slate-200 bg-slate-50">
          <p className="text-sm font-semibold text-slate-900">
            {user?.org?.name}
          </p>
          <p className="text-xs text-slate-600 mt-1">
            {user?.phone || 'admin@example.com'}
          </p>
        </div>

        {/* Menu Items */}
        <div className="py-1">
          {/* {!!user?.org?.mainAccount && (
            <button
              onClick={() => navigate('/sub-account')}
              className="w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors duration-150 cursor-pointer flex items-center gap-3 text-left"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 20h5v-1a4 4 0 00-4-4h-1M7 20H2v-1a4 4 0 014-4h1M12 12a4 4 0 100-8 4 4 0 000 8z"
                />
              </svg>
              <span>子账号</span>
            </button>
          )} */}
          <button
            onClick={() => navigate('/change-password')}
            className="w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors duration-150 cursor-pointer flex items-center gap-3 text-left"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
              />
            </svg>
            <span>修改密码</span>
          </button>
          <button
            onClick={() => navigate('/about')}
            className="w-full px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 transition-colors duration-150 cursor-pointer flex items-center gap-3 text-left"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.09 9a3 3 0 115.82 1c-.25.58-.8 1-1.4 1.2-.9.3-1.5 1.2-1.5 2.2v.5M12 17h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>操作指南</span>
          </button>

          <div className="my-1 border-t border-slate-200"></div>

          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-150 cursor-pointer flex items-center gap-3 text-left"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
            <span>退出登录</span>
          </button>
        </div>
      </div>
    </div>
  );
}
